export function isObj(obj) {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
}

export function isEmptyObj(obj) {
    return isObj(obj) && Object.keys(obj).length === 0;
}

export function isNullOrUndefined(val) {
    return typeof val === 'undefined' || val === null;
}
